<script>
export default {
    name: "MedicalNotesTab",

    data() {

        return {
            active:0,
            activeClass:`bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass:`bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {
 
      "vitals-tab-form": () => import('./tabs/Vitals.vue'),
      "physical-exam-form": () => import('./tabs/PhysicalExam.vue'),
      "chief-complains-form": () => import('./tabs/ChiefComplains.vue'),
      "history-of-illness-form": () => import('./tabs/HistoryOfIllness.vue'),
      "clinical-profile-form": () => import('./tabs/ClinicalProfile.vue'),
      "management-notes-form": () => import('./tabs/ManagementNotes.vue'),
    },
}
</script>
<template>
<div class="w-full max-w-none overflow-auto mt-2 p-tiny" style="height: 55vh;">
    <ul class="flex border-b-2 border-gray-500">
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=0"
           class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
           :class="active == 0 ? activeClass : inActiveClass">Vitals</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=4"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
          :class="active == 4 ? activeClass : inActiveClass">Chief Complains</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=2"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
          :class="active == 2 ? activeClass : inActiveClass">History Of Illness</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=1"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
          :class="active == 1 ? activeClass : inActiveClass">Physical Exam</a>
      </li>
      <li class="-mb-px mr-1">
        <a href="javascript:void(0)" @click.prevent="active=3"
          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
          :class="active == 3 ? activeClass : inActiveClass">Management Notes</a>
      </li>
    </ul>
    <div class="w-full" v-if="active==0">
      <vitals-tab-form />
    </div>
    <div class="w-full" v-if="active==1">
      <physical-exam-form />
    </div>
    <div class="w-full" v-if="active==4">
      <chief-complains-form />
    </div>
    <div class="w-full" v-if="active==2">
      <history-of-illness-form />
    </div>
    <div class="w-full" v-if="active==5">
      <clinical-profile-form />
    </div>
    <div class="w-full" v-if="active==3">
      <management-notes-form />
    </div>
</div>
</template>